module.exports = __webpack_public_path__ + "img/exploit_l.a6eaf7ed.png";